import {
  type CollectionByIdQueryParams,
  type CollectionItemByID,
} from '@/common/types/collection.type';
import { type ResponseItemType } from '@/common/types/response.type';
import { useQuery } from '@tanstack/react-query';

import Client from '@/common/utils/client.utility';

export type GetVendorCollectionDetail = (
  params: CollectionByIdQueryParams
) => Promise<ResponseItemType<CollectionItemByID>>;

export const getVendorCollectionDetail: GetVendorCollectionDetail = async (
  params: CollectionByIdQueryParams
) => {
  const client = new Client();

  return await client.get(
    '/v1/Assortment/Shopper/GetAssortmentDetails',
    params
  );
};

export default function usegetVendorCollectionDetail(
  params: CollectionByIdQueryParams
) {
  return useQuery({
    queryKey: ['Get-Vendor-Collection-Detail', params],

    queryFn: async () => await getVendorCollectionDetail(params),

    select: (data) => data?.data,

    retry: 1,

    staleTime: 600000,
  });
}
